import { Box } from '@factorialco/deprecated-design-system'

export const ImageBox = ({ url, name }: { url: string; name: string }) => {
  return (
    <Box
      flexDirection="row"
      overflowX="hidden"
      alignItems="center"
      justifyContent="flexStart"
      overflowY="hidden"
      style={{ maxWidth: '108px', height: '52px' }}
    >
      <img
        src={url}
        alt={name}
        style={{ objectFit: 'contain', height: '100%', borderRadius: '6px' }}
      />
    </Box>
  )
}
